import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import {
  blackListCountryRequest,
  countryRequest,
  networkProviderRequest,
} from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { format } from "date-fns";
import ReactTooltip from "react-tooltip";
import { withRouter } from "react-router-dom";
import CountryFlag from "react-country-flag";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import qs from "query-string";
import { MultiSelect } from "primereact/multiselect";

const Countries = () => {
  const userDetails = useSelector((state) => state.login.userDetails);
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([] || null);
  const [networks, setNetworks] = useState([] || null);
  const [selectedNetworks, setSelectedNetworks] = useState([]);
  const [addCountryModal, setAddCountryModal] = useState(false);
  const [editCountryModal, setEditCountryModal] = useState(false);
  const [openAssignNetworkModal, setOpenAssignNetworkModal] = useState(false);
  const [blacklistCountryModal, setBlacklistCountryModal] = useState(false);
  const [shortName, setShortName] = useState("");
  const [currency, setCurrency] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    shortName: "",
    region: "",
    subRegion: "",
    currency: "",
    status: "",
    parameters: "",
  });
  const [currencyFormData, setCurrencyFormData] = useState({
    name: "",
    code: ""
  });

  const handleCurrencyFormChange = (e) => {
    const { name, value } = e.target;
    setCurrencyFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const statusOptions = [
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" },
  ];

  const countryBodyTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <CountryFlag
          countryCode={rowData.shortName}
          svg
          style={{ width: "25px", height: "15px", marginRight: "8px" }}
        />
        {rowData.shortName}
      </div>
    );
  };

  const handleAddCountryDisplay = async () => {
    setFormData({
      name: "",
      shortName: "",
      region: "",
      subRegion: "",
      currency: "",
      status: "",
      parameters: "",
    }); // Reset form data
    setAddCountryModal(true); // Open the modal
  };

  const handleBlacklistCountryDisplay = async (rowData) => {
    setSelectedCountry(rowData);
    setBlacklistCountryModal(true);
  };

  const handleAssignNetworkDisplay = async (rowData) => {
    setSelectedCountry(rowData);
    await fetchNetworks(); // Fetch networks when modal opens
    setOpenAssignNetworkModal(true);
  };

  const handleEditCountryDisplay = async (rowData) => {
    setSelectedCountry(rowData); // Set the selected country data
    setFormData({
      id: rowData.id,
      name: rowData.name,
      shortName: rowData.shortName,
      region: rowData.region,
      subRegion: rowData.subRegion,
      currency: rowData.currency,
      status: rowData.status,
      parameters: rowData.parameters,
    }); // Populate form data
    setEditCountryModal(true); // Open the modal
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-pencil"
        className="p-button-success p-mr-2"
        onClick={() => handleEditCountryDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Update Status"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-times"
        className="p-button-danger p-mr-2"
        onClick={() => handleBlacklistCountryDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Blacklist"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={() => handleAssignNetworkDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Add extra currency"
        data-for="toolTip1"
        data-place="top"
      />
      <ReactTooltip id="toolTip1" />
    </>
  );

  const fetchData = async () => {
    setLoading(true);

    const requestData = {
      shortName: shortName || "",
      currency: currency || "",
      // size: "500",
      // page: "1",
    };

    const filteredRequestData = Object.fromEntries(
      Object.entries(requestData).filter(([key, value]) => value !== "")
    );

    const queryString = new URLSearchParams(filteredRequestData).toString();

    try {
      const response = await countryRequest(
        "get",
        `api/v1/countries/list-all?${queryString}`
      );

      if (response.code === "00") {
        setCountries(response.data || []); // Set data or empty array
      } else {
        setCountries([]); // No data, clear the table
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currency, shortName]); // Re-fetch data when filters change

  const getSearchedData = () => {
    fetchData(); // Re-fetch the data with the updated filters
  };

  const dateTemplate = (rowData) => {
    return <p>{format(new Date(rowData.createdAt), "yyyy-MM-dd HH:mm:ss")}</p>;
  };

  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "rgb(92, 74, 181)",
    fontWeight: "500",
  };

  const handleAddCountry = async () => {
    try {
      setLoading(true);
      const response = await countryRequest(
        "post",
        "api/v1/countries",
        JSON.stringify(formData)
      );

      if (response.status === 200) {
        console.log("Success", response.msg);
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      } else {
        console.log("Failed to fetch data:", response.msg);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleEditCountry = async () => {
    try {
      setLoading(true);
      const response = await countryRequest(
        "put",
        "api/v1/countries",
        formData
      );

      if (response.status === 200) {
        console.log("Success", response.msg);
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      } else {
        console.log("Failed to fetch data:", response.msg);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleBlacklistCountry = async () => {
    try {
      setLoading(true);

      // Prepare the data properly
      const blacklistData = {
        name: selectedCountry?.name,
        code: selectedCountry?.shortName,
        currency: selectedCountry?.currency,
      };

      const response = await blackListCountryRequest(
        "post",
        "api/v1/blacklistedcountry",
        blacklistData // Just pass the object, don't stringify here
      );

      if (response.code === "00") {
        // Adjust based on your API's success response
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Country blacklisted successfully",
          life: 3000,
        });
        setBlacklistCountryModal(false);
        fetchData(); // Refresh the data
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message || "Failed to blacklist country",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error blacklisting country:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "An error occurred",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchNetworks = async () => {
    try {
      const response = await networkProviderRequest(
        "get",
        `api/v1/networkandprovider/network/filter?size=1000`
      );
      if (response.code === "00") {
        const formattedNetworks = response.data.map((network) => ({
          label: network.name,
          value: network.id,
        }));
        setNetworks(formattedNetworks || []);
        console.log("Fetched networks:", formattedNetworks);
      } else {
        setNetworks([]);
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddExtraCurrency = async () => {
    try {
      setLoading(true);

      const countryShortName = selectedCountry?.shortName

      const payload = {
        ...currencyFormData,
        countryShortName: countryShortName
      }

      const response = await countryRequest(
        "post",
        "api/v1/currencies",
        JSON.stringify(payload)
      );

      if (response.data.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Networks assigned successfully",
          life: 3000,
        });
        setOpenAssignNetworkModal(false);
        setSelectedNetworks([]);
        fetchData();
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.data.msg || "Failed to assign networks",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error assigning networks:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.msg || "An error occurred",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  console.log("Available networks:", networks);
  console.log("Selected networks:", selectedNetworks);
  return (
    <section className="p-my-4 p-md-12 p-xl-12">
      <Toast ref={toast} />

      <div className="p-grid p-fluid p-mb-4">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Countries</span>
        </div>
      </div>

      <div className="card" style={{ paddingTop: "0px" }}>
        <div
          className="p-grid p-align-center p-justify-start p-fluid"
          style={{ paddingTop: "10px" }}
        >
          {/* Search Input */}
          <div className=" p-col-12 p-md-3">
            <label style={floatLabel}>CURRENCY</label>
            <div className="p-inputgroup">
              <InputText
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                placeholder="Enter Currency"
              />
            </div>
          </div>

          <div className=" p-col-12 p-md-3">
            <label style={floatLabel}>Short Name</label>
            <div className="p-inputgroup">
              <InputText
                value={shortName}
                onChange={(e) => setShortName(e.target.value)}
                placeholder="Enter short name"
              />
            </div>
          </div>
          <div className=" p-col-12 p-md-1">
            <Button
              onClick={getSearchedData}
              icon="pi pi-search"
              className="p-button-info"
              style={{ marginTop: "20px" }}
            />
          </div>
          <div className=" p-col-12 p-md-1 ">
            <Button
              icon="pi pi-plus"
              onClick={handleAddCountryDisplay}
              className="p-button-info"
              style={{
                fontSize: "15px",
                marginLeft: "auto",
                marginTop: "20px",
              }}
            />
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner
              style={{
                display: userDetails.showLoader,
                width: "40px",
                height: "40px",
                position: "fixed",
                top: "50%",
                left: "50%",
                bottom: "50%",
                right: "50%",
                zIndex: "1111111111",
              }}
              strokeWidth="3"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <DataTable
            value={countries}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "60rem" }}
            className="p-datatable-responsive-demo"
          >
            <Column
              field="id"
              header="Id"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="name"
              header="Name"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>

            <Column
              field="shortName"
              header="Short Name"
              style={{ width: "25%", fontSize: "13px" }}
              body={countryBodyTemplate}
            ></Column>
            <Column
              field="region"
              header="Region"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="subRegion"
              header="Sub Region"
              style={{ width: "30%", fontSize: "13px" }}
            ></Column>
            <Column
              field="currency"
              header="Currency"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>

            <Column
              field="status"
              header="Status"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="createdAt"
              header="Created At"
              style={{ width: "25%", fontSize: "13px" }}
              body={dateTemplate}
            ></Column>
            <Column
              header="Actions"
              style={{ width: "45%", fontSize: "13px" }}
              body={actions}
            ></Column>
          </DataTable>
        )}
      </div>
      <>
        <CustomDialog
          visible={blacklistCountryModal}
          header="Blacklist Country"
          onClose={() => setBlacklistCountryModal(false)}
        >
          Are you sure you want to blacklist{" "}
          <span style={{ color: "red", fontWeight: "bold" }}>
            {selectedCountry?.name || "N/A"}
          </span>
          <div className="p-col-12 p-grid p-mt-3 p-justify-end">
            <Button label="YES" onClick={handleBlacklistCountry} />
          </div>
        </CustomDialog>
        <CustomDialog
          visible={addCountryModal}
          header="Add Country Modal"
          onClose={() => setAddCountryModal(false)}
        >
          <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-mt-3">
                  <span className="p-float-label">
                    <InputText
                      name="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Name</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="shortName"
                      type="text"
                      value={formData.shortName}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Short Name</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="region"
                      type="text"
                      value={formData.region}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Region</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="subRegion"
                      type="text"
                      value={formData.subRegion}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Sub Region</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="currency"
                      type="text"
                      value={formData.currency}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Currency</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <Dropdown
                      name="status"
                      type="text"
                      value={formData.status}
                      options={statusOptions}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Status</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="parameters"
                      type="text"
                      value={formData.parameters}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Parameters</label>
                  </span>
                </div>

                <div
                  className="p-col-12 p-md-12 p-lg-12 p-xl-12"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    onClick={handleAddCountry}
                    label="Submit"
                    className="p-button-info p-mx-auto"
                    type="submit"
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomDialog>
        <CustomDialog
          visible={editCountryModal}
          header="Edit Country"
          onClose={() => setEditCountryModal(false)}
        >
          <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-mt-3">
                  <span className="p-float-label">
                    <InputText
                      name="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Name</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="shortName"
                      type="text"
                      value={formData.shortName}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Short Name</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="region"
                      type="text"
                      value={formData.region}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Region</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="subRegion"
                      type="text"
                      value={formData.subRegion}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Sub Region</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="currency"
                      type="text"
                      value={formData.currency}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Currency</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <Dropdown
                      name="status"
                      type="text"
                      value={formData.status}
                      options={statusOptions}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Status</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="parameters"
                      type="text"
                      value={formData.parameters}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Parameters</label>
                  </span>
                </div>

                <div
                  className="p-col-12 p-md-12 p-lg-12 p-xl-12"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    onClick={handleEditCountry}
                    label="Update"
                    className="p-button-info p-mx-auto"
                    type="submit"
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomDialog>
        <CustomDialog
          visible={openAssignNetworkModal}
          header="Add Extra Currency"
          onClose={() => setOpenAssignNetworkModal(false)}
        >
          <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                
                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="name"
                      type="text"
                      value={currencyFormData.name}
                      onChange={handleCurrencyFormChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Currency Name</label>
                  </span>
                </div>

                <div className="p-col-12 p-mt-2">
                  <span className="p-float-label">
                    <InputText
                      name="code"
                      type="text"
                      value={currencyFormData.code}
                      onChange={handleCurrencyFormChange}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Currency Code</label>
                  </span>
                </div>

                <div
                  className="p-col-12 p-md-12 p-lg-12 p-xl-12"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    onClick={handleAddExtraCurrency}
                    label="Add"
                    className="p-button-info p-mx-auto"
                    type="submit"
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomDialog>
      </>
    </section>
  );
};

export default withRouter(Countries);
